import { createDataWidget } from "@/widgets/common/createDataWidget";
import { mockFetch } from "@/widgets/common/mockFetch";
import { generatePrintVolumes } from "../PrintVolumeChart/mock";
import type { PrintVolumeGroupKey, PrintVolumePoint } from "../PrintVolumeChart/types";

/**
 * Widget state via the shared factory (D11) — its own slice (registered as
 * `printVolumeHorizontalChart` in the root reducer) so the two ink-channel
 * charts can hold different granularity selections side by side on the
 * Dashboard. The fetch takes the granularity as its param (OEE group
 * switcher parity); the mock generator is shared with the vertical chart.
 * Swapping in CubeJS replaces `mockFetch` with a real fetcher.
 */
export const printVolumeHorizontalChart = createDataWidget<
  PrintVolumePoint,
  PrintVolumeGroupKey | undefined
>({
  name: "printVolumeHorizontalChart",
  fetcher: mockFetch((group) => generatePrintVolumes(group ?? "month")),
});
